module.exports = __webpack_public_path__ + "img/default-upload-img.a47671a1.png";